import {
  getCachedCategoriesResource,
} from '@api/store.service'

const SAVE_MENU = 'SAVE_MENU'
const SAVE_UPDATED_MENU = 'SAVE_UPDATED_MENU'
// const SET_LOAD = 'SET_LOAD'

function addIsFilterable(categories = [], ids) {
  const c = categories || []
  for (let i = 0; i < c.length; i++) {
    const category = c[i];
    const categoryId = category.id;

    if (ids.includes(categoryId)) {
      category.is_filterable = true;
      category.is_linked = true;
    }

    if (category.children && 0 < category.children.length) {
      addIsFilterable(category.children, ids);
      const hasFilterableChild = category.children.some(child => child.is_filterable);
      if (hasFilterableChild) {
        category.is_filterable = true;
      }
    }
  }
}

function indexByIdToChildren(nodes) {
  const map = new Map()
  const stack = Array.isArray(nodes) ? [...nodes] : []

  while (stack.length) {
    const node = stack.pop()
    const children = (Array.isArray(node?.children) ? node.children : []).filter(c => c.active_product_count)
    map.set(node.id, children)
    if (children.length) stack.push(...children)
  }
  return map;
}

function filterByActiveProducts(nodes) {
  return nodes
    .map(node => {
      const filtered = { ...node }
      if (Array.isArray(node.children) && node.children.length) {
        filtered.children = filterByActiveProducts(node.children);
      }
      return filtered
    })
    .filter(node => node.active_product_count || node.children?.length)
}

export function createStore() {
  return {
    namespaced: true,
    state: {
      data: [],
      load: false,
      all: new Map(),
      menuIsLoading: false,
    },
    getters: {
      menu: state => state.data,
      all: state => state.all,
    },
    actions: {
      async getMenu({ commit, state }, payload) {
        if (state.data && state.data.length) return
        state.menuIsLoading = true
        try {
          const data = (await getCachedCategoriesResource.execute(payload))
          const response = JSON.parse(data)
          // const response = data
          state.menuIsLoading = false
          commit(SAVE_MENU, response.data)
        } catch (e) {
          state.menuIsLoading = false
        }
      },
      async addActiveChild({ commit, state }, payload) {
        return new Promise(resolve => {
          addIsFilterable(state.data, payload)
          commit(SAVE_MENU, state.data)
          resolve(state.data)
        })
      },
      setLoad({ state }, payload) {
        state.menuIsLoading = payload
      },
    },
    mutations: {
      [SAVE_UPDATED_MENU](state, payload) {
        // state.data = payload
        state.all = payload
      },
      [SAVE_MENU](state, payload) {
        state.data = filterByActiveProducts(payload || [])
        state.all = indexByIdToChildren(payload)
        // payload.forEach(p => {
        //   state.all.set(p.id, p.children)
        //   p.children.forEach(c => {
        //     state.all.set(c.id, c.children)
        //     c.children.forEach(b => {
        //       state.all.set(b.id, b.children)
        //       b.children.forEach(e => {
        //         state.all.set(e.id, e.children)
        //         e.children.forEach(r => {
        //           state.all.set(r.id, r.children)
        //         })
        //       })
        //     })
        //   })
        // })
      },
    },
  }
}
